






































































import { Component, Vue } from 'vue-property-decorator';
import alert from '@/store/modules/alert';
import * as api from '@/store/api';
import user from '@/store/modules/user';
import search from '@/store/modules/search';

@Component
export default class ImportSie extends Vue {
  fetching: boolean = false;
  isDragging: boolean = false;

  async mounted() {
    await user.setActiveSie(null);
    await user.setSelectedSie(null);
    await user.setSelectedSieBlob(null);
    await user.setActiveExternalUser(null);
    await search.setTerm('');
  }

  chooseFile() {
    const input: any = this.$refs.fileInput;
    input.click();
  }

  fileAdded() {
    const me = this;
    const store = this.$store;
    const router = this.$router;
    const formData = new FormData();
    const inputs: any = this.$refs.fileInput;
    const input: any = inputs.files[0];
    const name = input.name.toLowerCase();
    if (!name.endsWith('se') && !name.endsWith('si')) {
      me.clear();
      alert.setError({
        Code: 0,
        Message:
          'Felaktig filtyp. För att kunna importeras behöver filen vara i SIE-formatet.',
      });
      return;
    }
    formData.append('file', input);

    // me.fetching = true;
    user.setFetchingMessage('Analyserar SIE-fil...');
    user.setFetchingData(true);

    api
      .uploadSie(formData)
      .then((response: any) => {
        me.clear();
        const OrgNr: string = response.data;
        user.getUser('Analyserar SIE-fil').then(() => {
          // this.fetching = false;
          user.setFetchingData(false);
          this.$router.push({ name: 'sie', params: { OrgNr } });
        });
      })
      .catch((error) => {
        const apiError = error.error.response.data;
        me.clear();
        // this.fetching = false;
        user.setFetchingData(false);
        alert.setError(apiError);
      });
  }


  onDrop(event: any) {
    const input: any = this.$refs.fileInput;

    if (input) {
      input.files = event.dataTransfer.files;
      this.fileAdded();
      }
    this.isDragging = false;
    }

  onDragEnter() {
    this.isDragging = true;
  }

  onDragLeave() {
    this.isDragging = false;
  }

  clear() {
    const input: any = this.$refs.fileInput;
    input.type = 'text';
    input.type = 'file';
  }
}
